import React, { PureComponent } from 'react'
import moment from 'moment'
import { Col, Icon, Row, Button } from 'antd'
import { withTranslation } from 'react-i18next'
import _ from 'lodash'
import {
  bytesToSize,
  getImageDimension
} from '../../../../../../../../../../utils'
import './ShowDetailImage.scss'
import { api } from '../../../../../../../../../../services'

class ShowDetailImage extends PureComponent {
  state = {
    showDetail: false,
    loading: false,
    topicList: []
  }

  handleShowDetail = () => {
    this.setState(prevState => ({
      showDetail: !prevState.showDetail
    }))
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState(
        {
          topicList: [],
          showDetail: false
        },
        () => {
          this.getTopics()
        }
      )
    }
  }

  componentDidMount() {
    this.getTopics()
  }

  getTopics() {
    const { data } = this.props
    const { topicList } = this.state
    const topics = Array.isArray(data) ? [...data] : []
    const topicsIds = _.filter(topics, item => item.isSelected)

    if (!_.isEmpty(topicsIds) && !_.isEmpty(topicsIds[0].topics)) {
      this.setState({ loading: true })
      api.topics
        .getTopicsByIds(topicsIds[0].topics.join())
        .then(response => {
          let tempTopics = [...topicList]
          if (response?.data) {
            response.data.forEach(topic => {
              tempTopics.push(topic.title)
            })
          }
          this.setState({
            topicList: tempTopics,
            loading: false
          })
        })
        .catch(err => {
          console.error('Error fetching topics:', err)
          this.setState({ loading: false })
        })
    }
  }

  render() {
    const { showDetail, topicList, loading } = this.state
    const { removeCardSelection, data, t } = this.props

    return (
      <>
        {!_.isEmpty(data) &&
          data.map((item, ind) => {
            if (!item.isSelected) return null

            // Safely get image link
            const imageLink =
              item.ar_files?.find(obj => obj.media_format === 'IMAGE')?.link ||
              item.link

            // Safely get image dimensions
            let dimension = '...'
            try {
              if (item?.resizes?.medium_large) {
                dimension = `${getImageDimension(
                  item.resizes.medium_large
                )} ${t('image:pixel')}`
              }
            } catch (err) {
              console.error('Error getting image dimension:', err)
            }

            return (
              <div key={ind}>
                <section className="action-list">
                  <Row>
                    <Col span={12}>
                      <Icon type="close" onClick={removeCardSelection} />{' '}
                      {t('audio:close')}
                    </Col>
                    <Col span={12}>
                      <ul>{/* future action buttons can go here */}</ul>
                    </Col>
                  </Row>
                </section>

                <section className="action-list">
                  {imageLink ? (
                    <img className="img-fit-into-card" src={imageLink} alt="" />
                  ) : (
                    <p>{t('image:no_image_available')}</p>
                  )}
                </section>

                <section className="action-list audio-detail">
                  <div>
                    <strong>{item.title || item.filename}</strong>
                    <p>
                      {t('image:image')} - {bytesToSize(item.file_size || 0)}
                    </p>
                    <Row>
                      <Col span={12}>
                        <p>{t('audio:created')}</p>
                      </Col>
                      <Col span={12}>
                        <p>
                          {item.created_at
                            ? moment(item.created_at).format('DD MMM YYYY')
                            : '...'}
                        </p>
                      </Col>

                      <Col span={12}>
                        <p>{t('audio:description')}</p>
                      </Col>
                      <Col span={12}>
                        <p>{item.description || '...'}</p>
                      </Col>

                      {showDetail && (
                        <>
                          <Col span={12}>
                            <p>{t('image:dimension')}</p>
                          </Col>
                          <Col span={12}>
                            <p>{dimension}</p>
                          </Col>

                          <Col span={12}>
                            <p>{t('audio:topic')}</p>
                          </Col>
                          <Col span={12}>
                            <p>
                              {loading
                                ? 'loading...'
                                : topicList.length > 0
                                ? topicList.join(', ')
                                : '...'}
                            </p>
                          </Col>

                          <Col span={12}>
                            <p>{t('audio:key_words_tag')}</p>
                          </Col>
                          <Col span={12}>
                            <p>{item.keywords || '...'}</p>
                          </Col>
                        </>
                      )}
                    </Row>

                    <Button onClick={this.handleShowDetail}>
                      {!showDetail
                        ? t('media:show_more_details')
                        : t('media:show_less_details')}
                    </Button>
                  </div>
                </section>
              </div>
            )
          })}
      </>
    )
  }
}

export default withTranslation('audio')(ShowDetailImage)
